export const IS_LOADING_SCHEMA = 'IS_LOADING_SCHEMA'
export const ADD_TO_LIST_SCHEMA = 'ADD_TO_LIST_SCHEMA'
export const POPULATE_LIST_SCHEMA = 'POPULATE_LIST_SCHEMA'
export const DELETE_FROM_LIST_SCHEMA = 'DELETE_FROM_LIST_SCHEMA'
export const SET_CURRENT_SELECTION = 'SET_CURRENT_SELECTION'
export const SET_CURRENT_SCHEMA = 'SET_CURRENT_SCHEMA'
export const SET_ACTION = 'SET_ACTION'
export const SET_LAYER_TREE = 'SET_LAYER_TREE'



// WEBPACK FOOTER //
// ./src/store/modules/schemaFonctionnel/mutation_types.js